module.exports = __webpack_public_path__ + "media/images/gallery/constellations/andromeda/and_names-1958ec81b953086463903e7c8aedaf7a.png";